"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHistoryUrlEffect = exports.useThrottledFunc = exports.useDebouncedFunc = void 0;

var _react = require("react");

var _underscore = require("underscore");

var useDebouncedFunc = function useDebouncedFunc(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return (0, _react.useMemo)(function () {
    return (0, _underscore.debounce)(func, wait);
  }, deps);
};

exports.useDebouncedFunc = useDebouncedFunc;

var useThrottledFunc = function useThrottledFunc(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return (0, _react.useMemo)(function () {
    return (0, _underscore.throttle)(func, wait);
  }, deps);
}; // A hook for updating the browser URL, debounced to prevent security warnings from browsers


exports.useThrottledFunc = useThrottledFunc;

var useHistoryUrlEffect = function useHistoryUrlEffect(url) {
  var debounced = useDebouncedFunc(function (newURL) {
    history.replaceState(history.state, '', newURL);
  }, 300);
  (0, _react.useEffect)(function () {
    debounced(url);
  }, [url]);
};

exports.useHistoryUrlEffect = useHistoryUrlEffect;


//////////////////
// WEBPACK FOOTER
// ./js/utils/customHooks.js
// module id = 371
// module chunks = 5 6 7